// eslint-disable-next-line import/prefer-default-export
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'token',
  REFRESH_TOKEN: 'refresh_token',
  BRANCH_ID: 'branchId',
  BRANCH_NAME: 'branchName',
  ORGANIZATION_ID: 'organizationId',
  USER_FLOW: 'userFlow',
  NEW_ORG_ID: 'newOrgId',
  UPGRADED_ORG_ID: 'upgradedOrgId',
  NEW_BRANCH_ID: 'newBranchId',
  UPGRADED_BRANCH_ID: 'upgradedBranchId',
  MOBILE: 'mobile',
  USER_TYPE: 'userType',
  USER_ID: 'userId',
  USER_BRANCH_ID: 'userBranchId',
  USER_ORGANIZATION_ID: 'userOrganizationId',
  AUTHENTICATION_REDIRECTION: 'authentication-redirection',
  ACTIVITY_DETAILS: 'activity-details',
  SHOW_COFEE_INTRO_MODAL: 'showCofeeIntroModal',
  NEW_GROUP_NAME: 'newGroupName',
  GROUP_INFO_SELECTED_TAB: 'groupInfoSelectedTab',
  DISMISSED_DYNAMIC_COMPONENTS: 'dismissedDynamicComponents',
  DYNAMIC_COMPONENT_MIXPANEL_VIEWS: 'dynamicComponentMixpanelViews'
};
